import { v4 as uuid } from 'uuid';
import firebase from 'firebase/app';
import 'firebase/messaging';
import { apiResource, callApi } from 'services/api';
import apiConstant from 'common/apiConstants';

const initializedFirebaseApp = firebase.initializeApp({
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
});

let messaging;
if (firebase.messaging.isSupported()) {
  messaging = initializedFirebaseApp.messaging();
}

export const requestNotificationPermission = () =>
  new Promise((resolve, reject) => {
    if (messaging) {
      messaging
        .getToken({
          vapidKey: process.env.REACT_APP_FCM_VAPID_KEY,
        })
        .then((firebaseToken) => {
          resolve(firebaseToken);
        })
        .catch((err) => {
          reject(err);
        });
    }
  });

export const onMessageListener = () =>
  new Promise((resolve) => {
    if (messaging) {
      messaging.onMessage((payload) => {
        resolve(payload);
      });
    }
  });

export const storeFirebaseData = (token) => {
  let deviceIdentifier = document.cookie.replace(
    /(?:(?:^|.*;\s*)deviceIdentifier\s*=\s*([^;]*).*$)|^.*$/,
    '$1'
  );

  let tokenCookie = document.cookie.replace(
    /(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/,
    '$1'
  );

  if (deviceIdentifier && deviceIdentifier.length) {
    if (tokenCookie && tokenCookie.length) {
      if (tokenCookie !== token) {
        document.cookie = `token=${token}`;
        return registerFirebaseData(deviceIdentifier, token);
      }
    } else {
      document.cookie = `token=${token}`;
      return registerFirebaseData(deviceIdentifier, token);
    }
  } else {
    document.cookie = `deviceIdentifier=${uuid()}`;
    storeFirebaseData(token);
  }
};

const registerFirebaseData = (deviceIdentifier, token) => {
  return callApi(apiResource.resourceAPI, 'post', apiConstant.fcm, {
    deviceIdentifier,
    token,
  });
};
